var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58847e-09 6.00427C1.14302e-08 5.68211 0.2394 5.41586 0.550006 5.37372L0.636356 5.36791L13.3635 5.36791C13.7149 5.36791 13.9998 5.65282 13.9998 6.00427C13.9998 6.32643 13.7604 6.59268 13.4498 6.63482L13.3635 6.64063L0.636356 6.64063C0.284906 6.64063 3.39747e-09 6.35572 7.58847e-09 6.00427Z",
    fill: "#D9DEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7811 1.34131C7.53206 1.09334 7.53119 0.69042 7.77917 0.441373C8.0046 0.214967 8.35808 0.193667 8.6076 0.377975L8.67911 0.439435L13.8124 5.55065C14.0395 5.77675 14.0601 6.13151 13.8743 6.38102L13.8124 6.45249L8.67914 11.5645C8.43012 11.8125 8.0272 11.8117 7.7792 11.5627C7.55375 11.3363 7.53395 10.9827 7.7193 10.734L7.78107 10.6627L12.4613 6.00133L7.7811 1.34131Z",
    fill: "#D9DEF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.ba9707b6.svg";
export { ForwardRef as ReactComponent };